module.exports = __webpack_public_path__ + "media/Images/CloudWhite-ca49306b.png";